import { computed } from 'vue-demi';
import { state as ReselectState, mutation as ReselectMutations } from './store';

export function useReselect() {
  const needReselect = computed(() => ReselectState.needReselect.value); // 用户上传无效素材，需要重新选中
  const fileOptions = computed(() => ReselectState.fileOptions.value);
  const userReselect = computed(() => ReselectState.userReselect.value);
  const cameraWarningMsg = computed(() => ReselectState.cameraWarningMsg.value);
  const showWarning = computed(() => ReselectState.showWarning.value);

  const reselectWarning = ({ warningMsg }) => {
    console.log('handleUploadWarning', warningMsg);
    ReselectMutations.addWarning(warningMsg);
  };

  const onReselectFile = ({ append, files, selected }) => {
    if (append) {
      ReselectMutations.setReselect([...fileOptions.value, ...files], [...userReselect.value, ...selected]);
    } else {
      ReselectMutations.setReselect(files, selected);
    }
  };
  return {
    needReselect,
    fileOptions,
    userReselect,
    cameraWarningMsg,
    showWarning,
    reselectWarning,
    onReselectFile,
    handleReselectClick: ReselectMutations.handleReselectClick,
    hideWarning: ReselectMutations.hideWarning,
  };
}
